import { isInteger } from '@surveycake/utils';
import { isDevelopment } from 'app/shared/utils/development';
import Cookies, { CookieAttributes } from 'js-cookie';
import { IQuarantine } from './types';

function isRecoveryMinValid(recoveryMin?: number): recoveryMin is number {
  return typeof recoveryMin === 'number' && isInteger(recoveryMin);
}

export const Quarantine: IQuarantine = {
  isEnabled(surveyConfig) {
    const {
      quarantine_same_browser_duplicated,
      quarantine_same_browser_duplicated_recovery_min
    } = surveyConfig.data;

    return (
      Boolean(quarantine_same_browser_duplicated) &&
      isRecoveryMinValid(quarantine_same_browser_duplicated_recovery_min)
    );
  },
  isSameBrowserFlagInCookie(surveyConfig) {
    return Boolean(Cookies.get(`quarantineSameBrowser_${surveyConfig.surveyHash}`));
  },
  setSameBrowserFlagToCookie(surveyConfig) {
    const {
      surveyHash,
      data: { quarantine_same_browser_duplicated_recovery_min: recoveryMin }
    } = surveyConfig;
    const options: CookieAttributes = {
      secure: !isDevelopment,
      path: '/'
    };

    /**
     * The unit of expires is day.
     */
    if (isRecoveryMinValid(recoveryMin)) {
      options.expires =
        recoveryMin >= 0 ? recoveryMin / (60 * 24) : new Date(3000, 1, 1);
    }

    Cookies.set(`quarantineSameBrowser_${surveyHash}`, `true`, options);
  }
};
